import React from 'react';
import { SelectProps } from '@material-ui/core';
import { AutocompleteVariants } from 'components/core/forms/autocomplete/autocomplete';
import { Autocomplete } from '../autocomplete';
import {
  factoryFormFieldComponent,
  FormFieldSpecs,
} from '../utils/factory-form-field-component';

export type OptionType = { label: string; description?: string; value: string };
type SelectOnChange = SelectProps['onChange'];

export type AutocompleteSpecs = FormFieldSpecs<{
  options?: OptionType[];
  onAfterChange?: (selected: any) => void;
  leftLabel?: boolean;
  labelVariant?: number;
  disabled?: boolean;
  autocompleteVariant?: AutocompleteVariants;
  value?: string;
  disabledOptions?: string[];
}>;

export const AutocompleteController =
  factoryFormFieldComponent<AutocompleteSpecs>(
    ({
      autocompleteVariant,
      disabled,
      disabledOptions,
      error,
      label,
      labelVariant,
      leftLabel,
      name,
      onAfterChange,
      onBlur,
      onChange,
      options,
      placeholder,
      validations,
      value,
    }) => {
      const handleChange: SelectOnChange = (evt) => {
        onChange(evt);
        onAfterChange?.(evt);
      };

      return (
        <Autocomplete
          autocompleteVariant={autocompleteVariant}
          disableClearable
          disabled={disabled}
          disabledOptions={disabledOptions}
          error={!!error}
          helperText={error?.message}
          label={label}
          labelVariant={labelVariant}
          leftLabel={leftLabel}
          name={name}
          onBlur={onBlur}
          onChange={handleChange}
          optional={!validations?.required}
          options={options}
          placeholder={placeholder}
          value={value}
        />
      );
    },
    { componentName: 'AutocompleteController' },
  );
